/**
 * Searchable Indian GST state + district dropdowns.
 * District list is filtered by the selected state; custom district names are allowed.
 */
import SearchableSelect from './SearchableSelect';
import { GST_STATE_OPTIONS, applyStateSelection } from '../../../utils/invoiceSettingsForm';
import { districtSelectOptions } from '../../../constants/indianDistricts';

export default function GstLocationFields({
  stateCode = '',
  district = '',
  errors = {},
  onChange,
  required = true,
  disabled = false,
}) {
  const star = required ? <span className="text-danger">*</span> : null;

  function handleStateChange(code) {
    const next = applyStateSelection(code);
    Object.entries(next).forEach(([name, value]) => onChange(name, value));
  }

  return (
    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label fw-semibold" htmlFor="gst-state">
          State {star}
        </label>
        <SearchableSelect
          inputId="gst-state"
          name="pump_state_code"
          placeholder="Search state…"
          options={GST_STATE_OPTIONS}
          value={stateCode}
          isDisabled={disabled}
          onChange={handleStateChange}
          noOptionsMessage="No state found"
        />
        {errors.pump_state_code && <small className="text-danger">{errors.pump_state_code}</small>}
      </div>
      <div className="col-md-6">
        <label className="form-label fw-semibold" htmlFor="gst-district">
          District {star}
        </label>
        <SearchableSelect
          inputId="gst-district"
          name="pump_district"
          placeholder={stateCode ? 'Search district…' : 'Select state first'}
          options={districtSelectOptions(stateCode, district)}
          value={district}
          isDisabled={disabled || !stateCode}
          isCreatable
          onChange={(value) => onChange('pump_district', value)}
          noOptionsMessage="No district found — type to add"
        />
        {errors.pump_district && <small className="text-danger">{errors.pump_district}</small>}
      </div>
    </div>
  );
}
